import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9308d0b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "printing-paper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bolder text-uppercase" }, " bảng kê chi tiết nhập ", -1))
const _hoisted_3 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_4 = {
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_5 = {
  class: "text-center",
  style: {"font-size":"0.9rem"}
}
const _hoisted_6 = { class: "me-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-end mb-0 fst-italic",
  style: {"font-size":"0.8rem"}
}, "ĐVT: đồng", -1))
const _hoisted_8 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_9 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, PropType } from "vue";
import {
  IHoaDonNhapKhoResponseBase,
  IKhoResponseBase,
  ITaiKhoanTheoHopDongResponseBase,
} from "@/core/interfaces/ApiResponses";
import ChiTietNhapTable from "../table-components/ChiTietNhapTable.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import SignatureCol from "@/layout/_shared/SignatureCol.vue";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";


export default /*#__PURE__*/_defineComponent({
  __name: 'BangKeChiTietNhapPrintTemplate',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  from: { type: Date, default: () => new Date() },
  to: { type: Date, default: () => new Date() },
  items: {
    type: Array as PropType<IHoaDonNhapKhoResponseBase[]>,
    required: true,
  },
  kho: {
    type: Object as PropType<IKhoResponseBase | null>,
    default: null,
  },
  taiKhoanData: {
    type: Object as PropType<ITaiKhoanTheoHopDongResponseBase | null>,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);


const dateDisplay = computed(() => {
  if (props.from.getMonth() === props.to.getMonth()) {
    return `Tháng ${props.from.getMonth() + 1} năm ${props.from.getFullYear()}`;
  }

  return `Từ tháng ${
    props.from.getMonth() + 1
  } năm ${props.from.getFullYear()} đến tháng ${
    props.to.getMonth() + 1
  } năm ${props.to.getFullYear()}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PdfDocumentHeader, {
      "ten-don-vi": resolvedTenDonVi.value,
      "ten-don-vi-cha": resolvedTenDonViCha.value
    }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
    _createVNode(DivRow, { class: "mb-3" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 3 }),
        _createVNode(DivCol, { cols: 6 }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("p", _hoisted_3, _toDisplayString(dateDisplay.value), 1),
            _createElementVNode("p", _hoisted_4, " Nhập tại kho: " + _toDisplayString(__props.kho?.ten_kho), 1)
          ]),
          _: 1
        }),
        _createVNode(DivCol, { cols: 3 })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, " Tên đơn vị cấp vật tư, hàng hoá: " + _toDisplayString(__props.taiKhoanData?.ten_doi_tac), 1),
      _createElementVNode("span", null, "Tài khoản: " + _toDisplayString(__props.taiKhoanData?.ma_tk) + " / " + _toDisplayString(__props.taiKhoanData?.ma_ct), 1)
    ]),
    _hoisted_7,
    _createVNode(DivRow, null, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 12 }, {
          default: _withCtx(() => [
            _createVNode(ChiTietNhapTable, {
              "is-print-modal": true,
              items: __props.items,
              stripe: false
            }, null, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
      ]),
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
      ])
    ])
  ]))
}
}

})